import {Scene, Vector4, PlaneGeometry, ShaderMaterial, Mesh} from 'three'
import common from './common'
import shaders from './glsl/shaders'

import {commonUniforms} from './utils/common-uniforms'

export default class Halo {
  scene: Scene = new Scene()
  num: number = 6
  progress: Vector4 = new Vector4(0, 0, 0, 0)
  constructor() {
    this.init()
  }

  init() {
    for (let i = 0; i < this.num; i++) {
      const r = Math.PI * (i / this.num) * 2
      const geometry = new PlaneGeometry(2.0, 2.0)
      const material = new ShaderMaterial({
        vertexShader: shaders.haloOrbVert,
        fragmentShader: shaders.utils + shaders.haloOrbFrag,
        uniforms: {
          ...commonUniforms,
          uRandom: {
            value: new Vector4(Math.random(), Math.random(), Math.random(), Math.random()),
          },
          uResolution: {
            value: common.fbo_screenSize,
          },
          uProgress: {
            value: this.progress,
          },
        },
        depthTest: false,
        depthWrite: false,
        transparent: true,
      })

      const mesh = new Mesh(geometry, material)
      this.scene.add(mesh)

      mesh.position.z += 0.1 * i
      mesh.userData.radian = r
      mesh.userData.rotationSpeed = 0.2 + 0.3 * Math.random()
    }
  }

  update() {
    for (const mesh of this.scene.children) {
      mesh.userData.radian -= common.delta * mesh.userData.rotationSpeed * 4.0

      const x = Math.cos(mesh.userData.radian) * 0.1
      const y = Math.sin(mesh.userData.radian) * 0.1

      mesh.position.x = x
      mesh.position.y = y
    }
  }
}
